import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.about'), href: '/' },
    { label: t('footer.editorial'), href: '/' },
    { label: t('footer.contact'), href: '/' },
    { label: t('footer.privacy'), href: '/' },
    { label: t('footer.terms'), href: '/' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="section-padding max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                CSSBuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t('hero.subtitle').slice(0, 120)}...
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-primary text-sm"
            >
              {t('footer.visitMain')}
              <i className="ri-external-link-line ml-1.5"></i>
            </a>
          </div>

          {/* Links */}
          <div className="md:col-span-1">
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Links
            </h4>
            <div className="flex flex-col gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Main CTA */}
          <div className="md:col-span-1">
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              CSSBuy Spreadsheet
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary text-sm justify-center"
              >
                {t('cta.buttonSpreadsheet')}
                <i className="ri-external-link-line ml-1.5"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-accent text-sm justify-center"
              >
                {t('cta.buttonBuy')}
                <i className="ri-external-link-line ml-1.5"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 pt-6 border-t border-background-200">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-4xl">
            {t('footer.disclaimer')}
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-4 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">
            {t('footer.copyright')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            kaspreadsheet.com
          </a>
        </div>
      </div>
    </footer>
  );
}